import React from "react";

const EwalletTilesSkeleton = () => {
  return (
    <div className="ewallet_top_cnt_sction">
      <div className="row">
        {/* Skeleton for 4 tiles */}
        {[1, 2, 3, 4].map((index) => (
          <div key={index} className="col-xl-3 col-md-6 col-12 mb-3">
            <div className="ewallet_top_qc_balance_box">
              <div className="row align-items-center">
                <div className="ewallet_top_qc_balance_box_cnt">
                  <div className="ewallet_top_qc_balance_box_cnt_ico">
                    <div 
                      className="skeleton-shimmer rounded-circle"
                      style={{ 
                        width: "50px", 
                        height: "50px",
                        background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.5s infinite"
                      }}
                    ></div>
                  </div>
                  <div className="ewallet_top_qc_balance_box_cnt_cnt">
                    <div className="ewallet_top_qc_balance_box_cnt_head">
                      <div 
                        className="skeleton-shimmer"
                        style={{ 
                          width: "80%", 
                          height: "16px",
                          borderRadius: "4px",
                          background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.5s infinite"
                        }}
                      ></div>
                    </div>
                    <div className="box_amnt_dv">
                      <div className="ewallet_top_qc_balance_box_cnt_val ewallet_top_vl">
                        <div 
                          className="skeleton-shimmer"
                          style={{ 
                            width: "100%", 
                            height: "24px",
                            borderRadius: "4px",
                            marginBottom: "8px",
                            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite"
                          }}
                        ></div>
                      </div>
                      <div className="ewallt_top_comparison">
                        <div 
                          className="skeleton-shimmer"
                          style={{ 
                            width: "60%", 
                            height: "14px",
                            borderRadius: "4px",
                            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                            backgroundSize: "200% 100%",
                            animation: "shimmer 1.5s infinite"
                          }}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style>
    </div>
  );
};

export default EwalletTilesSkeleton;
